module.exports = __webpack_public_path__ + "8463823bc1645dc52a66b527af1eb99b.svg";